import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'
import { useLocation } from 'react-router-dom'
import { useSelector } from "react-redux";
import axios from 'axios';
import NavbarMob from '../components/NavbarMob'
import Navbar from '../components/Navbar'
import FooterMob from '../components/FooterMob'
import Footer from '../components/Footer'
import filter from '../images/Products/filter.png'
import product1 from '../images/Home/product2.webp'
import heart from '../images/Home/heart.png'
import filledHeart from '../images/Home/heart2.png';
// import cart from '../images/Home/cart.png'
import forward from '../images/Products/forwardpng.png'
import top from '../images/Products/top.png'
import Filter from '../components/Filter'
import { useStore } from '../useStore';


function SubCatProducts() {
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const isTab = useMediaQuery({ query: '(max-width: 1024px)' });

    const navigate = useNavigate();
    const home = () => {
        navigate('/')
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const userId = useSelector((state) => state.user.id);
    //('Logged in User ID:', userId);

    const [minPrice, setMinPrice] = useState(70); // Minimum price
    const [maxPrice, setMaxPrice] = useState(600); // Maximum price
    const [showFilter, setShowFilter] = useState(false);
    const [isPriceExpanded, setPriceExpanded] = useState(true);
    const [isColorsExpanded, setIsColorsExpanded] = useState(true);
    const [isSizeExpanded, setIsSizeExpanded] = useState(true);
    const [isDressExpanded, setIsDressExpanded] = useState(true);
    const [showFilterMob, setShowFilterMob] = useState(false);
    const location = useLocation();
    const { categoryId, categoryName } = location.state || {};
    const [loginId, setLoginId] = useState(null);
    const [offerPrices, setOfferPrices] = useState({});


    const { showDropdown, setShowDropdown } = useStore()
    const [loading, setLoading] = useState(true)
    //("ID", categoryId);

    useEffect(() => {
        // Get userId from localStorage
        const storedLoginId = localStorage.getItem('loginId');
        setLoginId(storedLoginId);
    }, []);


    const [products, setProducts] = useState([]);
    const [wishlistItems, setWishlistItems] = useState([]);

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const apiLocalUrl = process.env.REACT_APP_API_LOCAL_URL;

    // Fetch product data from the API
    useEffect(() => {
        const fetchProducts = async () => {
            //('aa');

            try {
                const response = await axios.get(`${apiBaseUrl}/getProductBySubCategory/BLACKBATON_2526?Id=${categoryId}`);
                setProducts(response.data); // Set the fetched products to state

                setTimeout(() => {
                    setLoading(false)
                }, 1000)
            } catch (error) {
                setLoading(false)
                console.error('Error fetching products:', error);
            }
        };

        const fetchNewArrival_BestSeller_LimitedSale = async () => {
            let option;
            if (categoryName === 'NEW ARRIVAL') {
                option = 'NewArrivals'
            } else if (categoryName === 'BEST SELLER') {
                option = 'BestSeller'
            } else if (categoryName === 'LIMITED SALE') {
                option = 'LimitedSale'
            }

            try {
                const response = await axios.get(`${apiBaseUrl}/getNewArrival_BestSeller_LimitedSale/BLACKBATON_2526?Id=${option}`);
                setProducts(response.data); // Set the fetched products to state
                setTimeout(() => {
                    setLoading(false)
                }, 1000)
            } catch (error) {
                setLoading(false)
                console.error('Error fetching products:', error);
            }
        };


        if (categoryName === 'NEW ARRIVAL' || categoryName === 'BEST SELLER' || categoryName === 'LIMITED SALE') {
            fetchNewArrival_BestSeller_LimitedSale();
        } else {
            fetchProducts();
        }

    }, [apiBaseUrl, categoryId, categoryName]);


    const handleMinChange = (e) => {
        const value = Math.min(Number(e.target.value), maxPrice - 10); // Ensure min < max
        setMinPrice(value);
    };

    const handleMaxChange = (e) => {
        const value = Math.max(Number(e.target.value), minPrice + 10); // Ensure max > min
        setMaxPrice(value);
    };


    const addToWishlist = async (product) => {
        const apiUrl = `${apiBaseUrl}/wishlist/add/BLACKBATON_2526`;

        const activeUserId = loginId || userId; // Use loginId if available, otherwise use userId

        if (!activeUserId) {
            console.error("No valid user ID found.");
            alert("User ID is missing.");
            return;
        }

        const payload = {
            ID: product.ID,
            ItemName: product.ItemName,
            MRP: product.MRP,
            ledcode: activeUserId,  // Use the determined user ID
            Qty: product.Qty
        };

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const result = await response.json();
                //("Added to wishlist:", result);
                // Update the local state
                setWishlistItems(prevItems => [...prevItems, product]);
                alert("Item added to wishlist!");
            } else {
                console.error("Failed to add to wishlist");
                alert("Already in Wishlist");
            }
        } catch (error) {
            console.error("Error:", error);
            alert("An error occurred while adding to wishlist.");
        }
    };

    useEffect(() => {
        const fetchWishlistItems = async () => {
            try {
                const activeUserId = loginId || userId; // Use loginId if available, otherwise use userId

                if (!activeUserId) return; // Ensure there's a valid userId before making the API call

                const response = await fetch(`${apiBaseUrl}/wishlist/items/BLACKBATON_2526/${activeUserId}`);
                const data = await response.json();

                if (data.success) {
                    setWishlistItems(data.items);
                }
            } catch (error) {
                console.error("Error fetching wishlist items:", error);
            }
        };

        fetchWishlistItems();
    }, [loginId, apiBaseUrl, userId]);

    const removeFromWishlist = async (productId) => {
        try {
            const response = await fetch(`${apiBaseUrl}/wishlist/delete/BLACKBATON_2526/${productId}`, {
                method: 'DELETE',
            });

            if (response.ok) {
                // Update the local state
                setWishlistItems(prevItems => prevItems.filter(item => item.ID !== productId));
                alert('Item removed from wishlist!');
            } else {
                console.error('Failed to remove item from wishlist');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('An error occurred while removing from wishlist.');
        }
    };

    // useEffect(() => {
    //     const fetchOfferPrices = async () => {
    //         const prices = {};
    //         for (const product of products) {
    //             try {
    //                 const res = await fetch(`${apiBaseUrl}/getOfferByItemId/${product.ID}`);
    //                 if (res.ok) {
    //                     const data = await res.json();
    //                     prices[product.ID] = data.OfferPrice;
    //                 }
    //             } catch (err) {
    //                 console.error(`Error fetching offer for product ${product.ID}`, err);
    //             }
    //         }
    //         setOfferPrices(prices);
    //     };

    //     if (products.length > 0) {
    //         fetchOfferPrices();
    //     }
    // }, [products]);



    const toggleFilter = () => {
        setShowFilter(!showFilter);
    };

    const closeFilter = () => {
        setShowFilter(!showFilter);
    };


    // Toggle function for 'Need Help'
    const togglePrice = () => {
        setPriceExpanded(!isPriceExpanded);
    };

    const toggleColors = () => {
        setIsColorsExpanded(!isColorsExpanded);
    };

    const toggleSize = () => {
        setIsSizeExpanded(!isSizeExpanded);
    };

    const toggleDress = () => {
        setIsDressExpanded(!isDressExpanded);
    };


    const handleFilterClick = () => {
        setShowFilterMob(true);
    };

    const closeFilterMob = () => {
        setShowFilterMob(false);
    };

    function encodeBase64(text) {
        return btoa(text);
    }

    // Encrypt and Navigate with Base64
    const fullimage = (id, itemName) => {
        navigate(`/fullimage?I=${encodeBase64(String(id))}&N=${encodeBase64(itemName)}`, { state: { id, itemName } });
    };

    // const fullimage = (id, itemName) => {
    //     navigate('/fullimage', { state: { id, itemName } });
    // };

    const [distinctColors, setDistinctColors] = useState({});


    // console.log(distinctColors,'distinctColors');


    const [visibleProducts, setVisibleProducts] = useState([]);
    const [animationTrigger, setAnimationTrigger] = useState(false);

    useEffect(() => {
        setVisibleProducts([]); // Reset visible products when products changes
        setAnimationTrigger(prev => !prev); // Trigger animation

        if (products.length > 0) {
            // Add products one by one with delay
            products.forEach((product, index) => {
                setTimeout(() => {
                    setVisibleProducts(prev => [...prev, product.ID]);
                }, index * 100); // 100ms delay between each product
            });
        }
    }, [products]);

    // Function to fetch colors
    const randomColorInPro = async (itemId) => {
        try {
            const response = await axios.get(`${apiBaseUrl}/getProductDetails/BLACKBATON_2526?Id=${itemId}`);
            if (response.status === 200) {
                const data = response.data;
                const distinctColors = [...new Set(
                    data.filter(item => item.ItemId === itemId).map(item => item.Color.trim())
                )];
                return distinctColors[0];
            }
        } catch (error) {
            console.error('Error:', error);
            return [];
        }
    };

    // Fetch colors for each product
    useEffect(() => {
        const fetchColors = async () => {
            const colorsMap = {};
            for (const product of products) {
                const distinctColors = await randomColorInPro(product.ID);
                colorsMap[product.ID] = distinctColors;
            }
            setDistinctColors(colorsMap);
        };

        if (products.length > 0) {
            fetchColors();
        }
    }, [products]);

    const [availability, setAvailability] = useState({});

    useEffect(() => {
        const checkImages = async () => {
            const results = {};

            for (const product of products) {
                const color = distinctColors[product.ID] || [];

                let code = product.displayFirst

                if (!product.displayFirst) {
                    code = `${product.ID}_${color}.webp`;
                }

                const imageUrl = `${apiLocalUrl}/uploads/${code}`;

                try {
                    const res = await fetch(imageUrl, { method: "HEAD" });
                    if (res.ok) {
                        results[product.ID] = res.ok;
                    } else {
                        results[product.ID] = false;
                    }

                } catch {

                    results[product.ID] = false;
                }
            }

            setAvailability(results);
        };

        if (Object.keys(distinctColors).length > 0) {
            checkImages();
        }
    }, [products, distinctColors]);

    // Check if product is visible (for animation)
    const isProductVisible = (productId) => {
        return visibleProducts.includes(productId);
    };

    return (
        <div className='min-h-screen flex flex-col ' onClick={() => setShowDropdown(false)}>
            {isMobile ? <NavbarMob /> : <Navbar />}

            <div className='w-full h-auto lg:px-12 px-3 py-6 flex flex-col lg:gap-12 gap-6 lg:mt-[175px] md:mt-[175px] mt-[120px] pb-12' >
                <div className='flex justify-between items-center'>
                    <div className='flex flex-row gap-2 items-center'>
                        <span className='lg:text-base text-xs font-[500] font-montserrat text-[#828282] cursor-pointer' onClick={home}>Home</span>
                        <span className='text-[#828282]'>{">"}</span>
                        <span className='lg:text-base text-xs font-[400] font-montserrat text-[#3C4242]'>{categoryName}</span>
                    </div>

                    {/* {!showFilter && (
                        <img src={filter} alt="filter" onClick={toggleFilter} className='cursor-pointer lg:flex hidden' />
                    )}
                    <img src={filter} alt="filter" className='cursor-pointer lg:hidden flex' onClick={handleFilterClick} /> */}

                </div>

                <div className='pb-12 flex flex-row gap-5'>
                    {showFilter && (
                        <div className='w-[350px] rounded-[2px] min-h-min max-h-max border-2 border-[#BEBCBD] flex flex-col '>
                            <div className='flex justify-between border-b-2 border-[#BEBCBD] p-5  items-center'>
                                <span className='text-[#807D7E] text-xl font-[400] font-montserrat'>Filter</span>
                                <img src={filter} alt="filter" onClick={closeFilter} className='cursor-pointer' />

                            </div>
                            <div className='flex flex-col border-b-2 border-[#BEBCBD] p-5  items-center gap-2'>
                                <div className='flex w-full justify-between items-center'>
                                    <span className='text-[#8A8989] font-[400] text-base font-montserrat'>Tops</span>
                                    <img src={forward} alt="forward" />
                                </div>
                                <div className='flex w-full justify-between items-center'>
                                    <span className='text-[#8A8989] font-[400] text-base font-montserrat'>Printed T-shirts</span>
                                    <img src={forward} alt="forward" />
                                </div>
                                <div className='flex w-full justify-between items-center'>
                                    <span className='text-[#8A8989] font-[400] text-base font-montserrat'>Plain T-shirts</span>
                                    <img src={forward} alt="forward" />
                                </div>
                                <div className='flex w-full justify-between items-center'>
                                    <span className='text-[#8A8989] font-[400] text-base font-montserrat'>Kurti</span>
                                    <img src={forward} alt="forward" />
                                </div>
                                <div className='flex w-full justify-between items-center'>
                                    <span className='text-[#8A8989] font-[400] text-base font-montserrat'>Boxers</span>
                                    <img src={forward} alt="forward" />
                                </div>
                                <div className='flex w-full justify-between items-center'>
                                    <span className='text-[#8A8989] font-[400] text-base font-montserrat'>Full sleeve T-shirts</span>
                                    <img src={forward} alt="forward" />
                                </div>
                                <div className='flex w-full justify-between items-center'>
                                    <span className='text-[#8A8989] font-[400] text-base font-montserrat'>Joggers</span>
                                    <img src={forward} alt="forward" />
                                </div>
                                <div className='flex w-full justify-between items-center'>
                                    <span className='text-[#8A8989] font-[400] text-base font-montserrat'>Payjamas</span>
                                    <img src={forward} alt="forward" />
                                </div>
                                <div className='flex w-full justify-between items-center'>
                                    <span className='text-[#8A8989] font-[400] text-base font-montserrat'>Jeans</span>
                                    <img src={forward} alt="forward" />
                                </div>
                            </div>

                            <div className="flex justify-between border-b-2 border-[#BEBCBD] p-5 items-center cursor-pointer" onClick={togglePrice}>
                                <span className="text-[#807D7E] text-xl font-[600] font-montserrat">Price</span>
                                <img src={top} alt="top" className={`transform transition-transform duration-300 ${isPriceExpanded ? 'rotate-180' : ''
                                    }`} />
                            </div>

                            {isPriceExpanded && (
                                < div className="flex flex-col border-b-2 border-[#BEBCBD] px-5 py-8 items-center gap-8 w-full">
                                    <div className="w-full relative flex items-center ">
                                        <input
                                            type="range"
                                            min="0"
                                            max="1000"
                                            step="10"
                                            value={minPrice}
                                            onChange={handleMinChange}
                                            className="absolute z-20 appearance-none w-full h-2 bg-transparent pointer-events-auto"
                                            style={{
                                                accentColor: "black",
                                            }}
                                        />

                                        {/* Range Slider for Max */}
                                        <input
                                            type="range"
                                            min="0"
                                            max="1000"
                                            step="10"
                                            value={maxPrice}
                                            onChange={handleMaxChange}
                                            className="absolute z-20 appearance-none w-full h-2 bg-transparent pointer-events-auto"
                                            style={{
                                                accentColor: "black",
                                            }}
                                        />

                                        {/* Track */}
                                        <div className="w-full h-1 bg-gray-300  relative">
                                            <div
                                                className="absolute h-1 bg-black "
                                                style={{
                                                    left: `${(minPrice / 1000) * 100}%`,
                                                    right: `${100 - (maxPrice / 1000) * 100}%`,
                                                }}
                                            ></div>
                                        </div>
                                    </div>

                                    {/* Price Labels */}
                                    <div className="flex justify-between w-full">
                                        <div className="w-[97px] h-[32px]  rounded-[8px] border-2 border-[#BEBCBD] flex justify-center items-center text-lg font-[400] font-montserrat">
                                            ₹{minPrice}
                                        </div>
                                        <div className="w-[97px] h-[32px] rounded-[8px] border-2 border-[#BEBCBD] flex justify-center items-center text-lg font-[400] font-montserrat">
                                            ₹{maxPrice}
                                        </div>
                                    </div>
                                </div>

                            )}


                            <div className="flex justify-between border-b-2 border-[#BEBCBD] p-5 items-center cursor-pointer" onClick={toggleColors}>
                                <span className="text-[#807D7E] text-xl font-[600] font-montserrat">Colors</span>
                                <img src={top} alt="top" className={`transform transition-transform duration-300 ${isColorsExpanded ? 'rotate-180' : ''
                                    }`} />
                            </div>

                            {isColorsExpanded && (
                                <div className="flex flex-col items-center border-b-2 border-[#BEBCBD] px-5 py-8 gap-4">
                                    <div className='grid grid-cols-4 gap-4'>
                                        <div className='flex flex-col gap-2 items-center'>
                                            <div className='w-[37px] h-[37px] rounded-[12px] bg-[#8434E1] border-2 border-[#F4F1F1]'></div>
                                            <span className='text-[#8A8989] text-sm font-[400] font-montserrat'>Purple</span>
                                        </div>
                                        <div className='flex flex-col gap-2 items-center'>
                                            <div className='w-[37px] h-[37px] rounded-[12px] bg-[black] border-2 border-[#F4F1F1]'></div>
                                            <span className='text-[#8A8989] text-sm font-[400] font-montserrat'>Black</span>
                                        </div>
                                        <div className='flex flex-col gap-2 items-center'>
                                            <div className='w-[37px] h-[37px] rounded-[12px] bg-[red] border-2 border-[#F4F1F1]'></div>
                                            <span className='text-[#8A8989] text-sm font-[400] font-montserrat'>Red</span>
                                        </div>
                                        <div className='flex flex-col gap-2 items-center'>
                                            <div className='w-[37px] h-[37px] rounded-[12px] bg-[orange] border-2 border-[#F4F1F1]'></div>
                                            <span className='text-[#8A8989] text-sm font-[400] font-montserrat'>Orange</span>
                                        </div>


                                        <div className='flex flex-col gap-2 items-center'>
                                            <div className='w-[37px] h-[37px] rounded-[12px] bg-[navy] border-2 border-[#F4F1F1]'></div>
                                            <span className='text-[#8A8989] text-sm font-[400] font-montserrat'>Navy</span>
                                        </div>
                                        <div className='flex flex-col gap-2 items-center'>
                                            <div className='w-[37px] h-[37px] rounded-[12px] bg-[white] border-2 border-[#F4F1F1]'></div>
                                            <span className='text-[#8A8989] text-sm font-[400] font-montserrat'>White</span>
                                        </div>
                                        <div className='flex flex-col gap-2 items-center'>
                                            <div className='w-[37px] h-[37px] rounded-[12px] bg-[#D67E3B] border-2 border-[#F4F1F1]'></div>
                                            <span className='text-[#8A8989] text-sm font-[400] font-montserrat'>Broom</span>
                                        </div>
                                        <div className='flex flex-col gap-2 items-center'>
                                            <div className='w-[37px] h-[37px] rounded-[12px] bg-[green] border-2 border-[#F4F1F1]'></div>
                                            <span className='text-[#8A8989] text-sm font-[400] font-montserrat'>Green</span>
                                        </div>


                                        <div className='flex flex-col gap-2 items-center'>
                                            <div className='w-[37px] h-[37px] rounded-[12px] bg-[yellow] border-2 border-[#F4F1F1]'></div>
                                            <span className='text-[#8A8989] text-sm font-[400] font-montserrat'>Yellow</span>
                                        </div>
                                        <div className='flex flex-col gap-2 items-center'>
                                            <div className='w-[37px] h-[37px] rounded-[12px] bg-[gray] border-2 border-[#F4F1F1]'></div>
                                            <span className='text-[#8A8989] text-sm font-[400] font-montserrat'>Gray</span>
                                        </div>
                                        <div className='flex flex-col gap-2 items-center'>
                                            <div className='w-[37px] h-[37px] rounded-[12px] bg-[pink] border-2 border-[#F4F1F1]'></div>
                                            <span className='text-[#8A8989] text-sm font-[400] font-montserrat'>Pink</span>
                                        </div>
                                        <div className='flex flex-col gap-2 items-center'>
                                            <div className='w-[37px] h-[37px] rounded-[12px] bg-[blue] border-2 border-[#F4F1F1]'></div>
                                            <span className='text-[#8A8989] text-sm font-[400] font-montserrat'>Blue</span>
                                        </div>


                                    </div>
                                </div>
                            )}



                            <div className="flex justify-between border-b-2 border-[#BEBCBD] p-5 items-center cursor-pointer" onClick={toggleSize}>
                                <span className="text-[#807D7E] text-xl font-[600] font-montserrat">Size</span>
                                <img src={top} alt="top" className={`transform transition-transform duration-300 ${isSizeExpanded ? 'rotate-180' : ''
                                    }`} />
                            </div>

                            {isSizeExpanded && (
                                <div className="flex flex-col items-center border-b-2 border-[#BEBCBD] px-5 py-8 gap-4">
                                    <div className='grid grid-cols-3 gap-4'>
                                        <div className='flex flex-col gap-2 items-center'>
                                            <div className='w-[61px] h-[32px] rounded-[12px]  border-2 border-[#BEBCBD] flex justify-center items-center font-[600] text-sm font-montserrat'>
                                                XXS
                                            </div>
                                        </div>
                                        <div className='flex flex-col gap-2 items-center'>
                                            <div className='w-[61px] h-[32px] rounded-[12px]  border-2 border-[#BEBCBD] flex justify-center items-center font-[600] text-sm font-montserrat'>
                                                XL
                                            </div>                                    </div>
                                        <div className='flex flex-col gap-2 items-center'>
                                            <div className='w-[61px] h-[32px] rounded-[12px]  border-2 border-[#BEBCBD] flex justify-center items-center font-[600] text-sm font-montserrat'>
                                                XS
                                            </div>                                    </div>



                                        <div className='flex flex-col gap-2 items-center'>
                                            <div className='w-[61px] h-[32px] rounded-[12px]  border-2 border-[#BEBCBD] flex justify-center items-center font-[600] text-sm font-montserrat'>
                                                S
                                            </div>                                    </div>
                                        <div className='flex flex-col gap-2 items-center'>
                                            <div className='w-[61px] h-[32px] rounded-[12px]  border-2 border-[#BEBCBD] flex justify-center items-center font-[600] text-sm font-montserrat'>
                                                M
                                            </div>                                    </div>
                                        <div className='flex flex-col gap-2 items-center'>
                                            <div className='w-[61px] h-[32px] rounded-[12px]  border-2 border-[#BEBCBD] flex justify-center items-center font-[600] text-sm font-montserrat'>
                                                L
                                            </div>                                    </div>


                                        <div className='flex flex-col gap-2 items-center'>
                                            <div className='w-[61px] h-[32px] rounded-[12px]  border-2 border-[#BEBCBD] flex justify-center items-center font-[600] text-sm font-montserrat'>
                                                XXL
                                            </div>                                    </div>
                                        <div className='flex flex-col gap-2 items-center'>
                                            <div className='w-[61px] h-[32px] rounded-[12px]  border-2 border-[#BEBCBD] flex justify-center items-center font-[600] text-sm font-montserrat'>
                                                3XL
                                            </div>                                    </div>
                                        <div className='flex flex-col gap-2 items-center'>
                                            <div className='w-[61px] h-[32px] rounded-[12px]  border-2 border-[#BEBCBD] flex justify-center items-center font-[600] text-sm font-montserrat'>
                                                4XL
                                            </div>                                    </div>



                                    </div>
                                </div>
                            )}

                            <div className="flex justify-between border-b-2 border-[#BEBCBD] p-5 items-center cursor-pointer" onClick={toggleDress}>
                                <span className="text-[#807D7E] text-xl font-[600] font-montserrat">Dress Style</span>
                                <img src={top} alt="top" className={`transform transition-transform duration-300 ${isDressExpanded ? 'rotate-180' : ''
                                    }`} />
                            </div>

                            {isDressExpanded && (
                                <div className='flex flex-col  p-5  items-center gap-2'>
                                    <div className='flex w-full justify-between items-center'>
                                        <span className='text-[#8A8989] font-[400] text-base font-montserrat'>T-shirts</span>
                                        <img src={forward} alt="forward" />
                                    </div>
                                    <div className='flex w-full justify-between items-center'>
                                        <span className='text-[#8A8989] font-[400] text-base font-montserrat'>Pants</span>
                                        <img src={forward} alt="forward" />
                                    </div>
                                    <div className='flex w-full justify-between items-center'>
                                        <span className='text-[#8A8989] font-[400] text-base font-montserrat'>Shorts</span>
                                        <img src={forward} alt="forward" />
                                    </div>
                                    <div className='flex w-full justify-between items-center'>
                                        <span className='text-[#8A8989] font-[400] text-base font-montserrat'>Bermuda Shorts</span>
                                        <img src={forward} alt="forward" />
                                    </div>
                                    <div className='flex w-full justify-between items-center'>
                                        <span className='text-[#8A8989] font-[400] text-base font-montserrat'>Gym Wear</span>
                                        <img src={forward} alt="forward" />
                                    </div>
                                    <div className='flex w-full justify-between items-center'>
                                        <span className='text-[#8A8989] font-[400] text-base font-montserrat'>Full sleeve T-shirts</span>
                                        <img src={forward} alt="forward" />
                                    </div>
                                    <div className='flex w-full justify-between items-center'>
                                        <span className='text-[#8A8989] font-[400] text-base font-montserrat'>Jackets</span>
                                        <img src={forward} alt="forward" />
                                    </div>
                                    <div className='flex w-full justify-between items-center'>
                                        <span className='text-[#8A8989] font-[400] text-base font-montserrat'>Sleeveless</span>
                                        <img src={forward} alt="forward" />
                                    </div>
                                    <div className='flex w-full justify-between items-center'>
                                        <span className='text-[#8A8989] font-[400] text-base font-montserrat'>Swimming Suits</span>
                                        <img src={forward} alt="forward" />
                                    </div>
                                    <div className='flex w-full justify-between items-center'>
                                        <span className='text-[#8A8989] font-[400] text-base font-montserrat'>Boxers</span>
                                        <img src={forward} alt="forward" />
                                    </div>
                                    <div className='flex w-full justify-between items-center'>
                                        <span className='text-[#8A8989] font-[400] text-base font-montserrat'>Sliders</span>
                                        <img src={forward} alt="forward" />
                                    </div>
                                    <div className='flex w-full justify-between items-center'>
                                        <span className='text-[#8A8989] font-[400] text-base font-montserrat'>Water Bottle & Shaker</span>
                                        <img src={forward} alt="forward" />
                                    </div>
                                    <div className='flex w-full justify-between items-center'>
                                        <span className='text-[#8A8989] font-[400] text-base font-montserrat'>Cut T-shirts</span>
                                        <img src={forward} alt="forward" />
                                    </div>
                                    <div className='flex w-full justify-between items-center'>
                                        <span className='text-[#8A8989] font-[400] text-base font-montserrat'>Polo T-shirts</span>
                                        <img src={forward} alt="forward" />
                                    </div>
                                    <div className='flex w-full justify-between items-center'>
                                        <span className='text-[#8A8989] font-[400] text-base font-montserrat'>Hoodies</span>
                                        <img src={forward} alt="forward" />
                                    </div>
                                    <div className='flex w-full justify-between items-center'>
                                        <span className='text-[#8A8989] font-[400] text-base font-montserrat'>Socks</span>
                                        <img src={forward} alt="forward" />
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    {products.length > 0 ? (
                        <div
                            className={`grid w-full gap-5 ${showFilter ? "lg:grid-cols-3 grid-cols-2" : "lg:grid-cols-4 md:grid-cols-3 grid-cols-2"
                                }`}
                        >
                            {products.map((product, index) => {
                                // const color = distinctColors[product.ID] || [];
                                // const code = `${product.ID}_${color}`.

                                const isAvailable = availability[product.ID];
                                const isVisible = isProductVisible(product.ID);

                                const color = distinctColors[product.ID] || [];

                                let code = product.displayFirst

                                if (!product.displayFirst) {
                                    code = `${product.ID}_${color}.webp`;
                                }


                                // ✅ Skip unavailable images
                                if (isAvailable === false) return null;

                                return (
                                    <div key={product.ID}
                                        className={`flex flex-col gap-2 cursor-pointer transition-all duration-500 ease-out transform ${isVisible
                                            ? 'opacity-100 translate-y-0 scale-100'
                                            : 'opacity-0 translate-y-0 scale-95'
                                            }`}
                                        onClick={() => fullimage(product.ID, product.ItemName)}
                                        style={{
                                            transitionDelay: isVisible ? `${index * 100}ms` : '0ms'
                                        }}>
                                        <div className='lg:h-[382px] md:h-[300px] h-[200px] rounded-[12px] bg-[#EEEEEE] flex items-center justify-center relative'>
                                            {isAvailable === undefined && (
                                                <div className="absolute inset-0 flex items-center justify-center">
                                                    <div className="w-6 h-6 border-4 border-gray-300 border-t-transparent rounded-full animate-spin"></div>
                                                </div>
                                            )}

                                            {isAvailable === true && (
                                                <img
                                                    src={`${apiLocalUrl}/uploads/${code}?v=${Date.now()}`}
                                                    alt={product.ItemName}
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = product1;
                                                    }}
                                                    className='mix-blend-multiply w-full h-full rounded-[12px] object-cover transition-transform duration-500 hover:scale-105'
                                                />
                                            )}

                                            <div className='absolute top-0 left-0 w-full h-full lg:p-6 p-2 flex justify-end'>
                                                <div
                                                    className='lg:w-[33px] w-[23px] lg:h-[33px] h-[23px] rounded-full bg-[white] flex justify-center items-center cursor-pointer'
                                                    onClick={(e) => {
                                                        e.stopPropagation(); // Prevents the main div's click event
                                                        if (wishlistItems.some(item => item.ID === product.ID)) {
                                                            // Item is in wishlist, remove it
                                                            removeFromWishlist(product.ID);
                                                        } else {
                                                            // Item is not in wishlist, add it
                                                            addToWishlist(product);
                                                        }
                                                    }}
                                                >
                                                    <img
                                                        src={wishlistItems.some(item => item.ID === product.ID) ? filledHeart : heart}
                                                        alt="heart"
                                                    />
                                                </div>
                                            </div>

                                        </div>
                                        <div className='flex justify-between w-full'>
                                            <div className='flex flex-col gap-1 w-full'>
                                                <span className='lg:text-base text-xs font-[600] font-montserrat text-left'>{product.ItemName}</span>
                                                {/* <div className='lg:w-[110px] lg:h-[35px] w-full h-[30px] rounded-[24px] border-2 border-[black] flex flex-row gap-1 justify-center items-center cursor-pointer'>
                                            <img src={cart} alt="cart" />
                                            <span className='text-xs font-[500] font-montserrat'>Add to Cart</span>
                                        </div> */}

                                            </div>
                                            <div className='flex flex-col gap-1 items-end'>
                                                <div className='lg:w-[84px] lg:h-[37px] w-[70px] h-[30px] text-red-600 rounded-[8px] bg-[#F6F6F6] flex justify-center items-center text-sm font-[700] font-montserrat'>
                                                    ₹{product.MRP}
                                                </div>
                                                {/* <span className="text-sm font-montserrat lg:flex hidden text-nowrap">
                                                    Offer Price:
                                                    <span className="line-through text-gray-500 ml-1">₹{product.MRP}</span>
                                                    <span className="text-red-600 font-bold ml-1">₹{offerPrices[product.ID] || product.MRP}</span>
                                                </span>
                                                <span className="text-sm font-montserrat lg:hidden flex text-nowrap">

                                                    <span className="line-through text-gray-500 ml-1">₹{product.MRP}</span>
                                                    <span className="text-red-600 font-bold ml-1">₹{offerPrices[product.ID] || product.MRP}</span>
                                                </span> */}
                                            </div>


                                        </div>
                                    </div>
                                )
                            })}

                        </div>
                    ) : loading ? (
                        <div className="flex justify-center items-center py-4">
                            <div className="animate-spin rounded-full h-6 w-6 border-t-2 border-b-2 border-gray-600"></div>
                        </div>
                    ) : (
                        <div className='font-[400] text-base font-montserrat'>
                            No products available!
                        </div>
                    )}
                </div>

            </div>


            {showFilterMob && <Filter closeFilterMob={closeFilterMob} />}
            {isTab ? <FooterMob /> : <Footer />}
        </div >

    )
}

export default SubCatProducts